import store from '@/store/index';
import { BaseSubject } from '../BaseSubject.model';
import { textSize } from '@/utils/textSize';
import { getContentWidth } from '@/utils/contentWidth';

import { PADDING_TOP, PAGE_SIZE_CELL } from '@/subjects/constant';
//@ts-ignore
let answerPanelState = store.state.answerPanel;
// const TAG_P_HEIGHT = TAG_P_HEIGHT; // 一个p元素的固定高度
import { TAG_P_HEIGHT } from '@/subjects/constant';
const TH_HEIGHT = 40; //标题高度
const MARGIN_BOTTOM = 10; // 每个页面底部空白的高度值为10px
let PADDING_TOP_HEIGHT = PADDING_TOP; // 填空题解答题英语作文题的padding高度
const BORDER_HEIGHT = 1;
export class WriteEnModel extends BaseSubject {
  totalScore?: number = 50;
  /**
   * 行数默认
   * */

  rowCount?: any;
  /**
   * 自定义编辑
   */
  types: number;
  /**
   * 展示类型
   */
  sty: number;
  /**
   * 存储html片段
   * */
  //@ts-ignore
  htmlArray: any;
  cacheInnerHTML: string = '';

  constructor(obj?: {
    name?: any;
    sty?: number;
    types?: number;
    rowCount?: any;
    htmlArray?: any;
    totalScore?: number;
    start?: number;
    items?: any[];
  }) {
    super(obj);
    obj = obj || {};
    this.types = 4;
    this.type = 4; // 英文作文标识
    this.sty = obj.sty || 1; // 1、单行
    this.name = obj.name || '作文（英）';
    this.rowCount = obj.rowCount || 10;
    this.totalScore = obj.totalScore || 20;
    this.start = obj.start || 1;
    this.htmlArray = obj.htmlArray || [];
    this.items = [];
    this.items.push({
      no: obj.start,
    });
    this.end = '';
  }

  render(options: any = {}) {
    const { hurdleReset } = options; // 不是通过二栏三栏render的
    this.htmlArray = [];
    const rowCount = this.rowCount;
    // 空格宽度
    let nbNode = document.querySelector('.text-size-dom')
    let nbWidth = nbNode ? nbNode.getBoundingClientRect().width : 0
    // 计算容器内容宽度
    const contentWidth = getContentWidth();
    const columnNum = Math.floor(contentWidth / nbWidth);
    let html = ''; // 每一行的html代码
    for (let index = 0; index < columnNum - 3; index++) {
      html += `&nbsp;`;
    }    
    for (let i = 0; i < rowCount; i++) {
      if (i == 0) {
        if (this.sty === 1) {
          // this.htmlArray.push(
          //   `<p class='row underline ${i}'><span style="text-decoration: underline;font-family: '宋体' !important;">&#8203;${html.slice(
          //     String(this.start).length * 18 // 这里的18是一个数字换算nbsp的长度
          //   )}</span>&#8203;</p>`
          // );
          this.htmlArray.push(`<p class='row underline'><span style="text-decoration: underline;font-family: '宋体' !important;">&#8203;${html}</span>&#8203;</p>`);
        } else {
          let contentHtml = '';
          for (let i = 0; i < 4; i++) {
            contentHtml += `<a class='e-u'>${html.slice(
              String(this.start).length * 18 // 这里的18是一个数字换算nbsp的长度
            )}</span>`;
          }
          this.htmlArray.push(`<p class='row underline four-lines' style="font-family: '宋体' !important;">${contentHtml}</p>`);
        }
      } else {
        if (this.sty === 1) {
          this.htmlArray.push(`<p class='row underline'><span style="text-decoration: underline;font-family: '宋体' !important;">&#8203;${html}</span>&#8203;</p>`);
        } else {
          let contentHtml = '';
          for (let i = 0; i < 4; i++) {
            contentHtml += `<a class='e-u'>${html.slice(
              String(this.start).length * 18 // 这里的18是一个数字换算nbsp的长度
            )}</span>`;
          }
          this.htmlArray.push(`<p class='row underline four-lines' style="font-family: '宋体' !important;">${contentHtml}</p>`);
        }
      }
    }
    if (!hurdleReset && this.innerHTML && this.innerHTML.length && !this.fromEdit) {
      this.cacheInnerHTML = this.innerHTML;
      return console.log('当前html有值的情况',);
    } else {
      this.cacheInnerHTML = this.innerHTML = this.htmlArray.join('');
    }
  }

  appendToPage(
    state: any,
    // pageCell: { contentHeight: number; value: string[] }[],
    pageHeight: number,
    newTopicHeight: number
  ) {
    let currentPage = state.pageCell.length - 1;
    // this.rows.forEach(row => this.insertToPage(pageCell, row, pageHeight));
    if (this.page.isSurplusPage(state, currentPage, TH_HEIGHT + TAG_P_HEIGHT + 20)) {
      state.pageCell[state.pageCell.length - 1].fillTopiclist.push({
        ...this,
        hasTitle: true,
        initDragHeight: this.initDragHeight || this.rowCount * TAG_P_HEIGHT + PADDING_TOP_HEIGHT,
        innerHTML: this.cacheInnerHTML,
      });
      newTopicHeight = this.initDragHeight || this.rowCount * TAG_P_HEIGHT + PADDING_TOP_HEIGHT; // 12px是编辑器头部的高度
      this.recursionCutPage(state, newTopicHeight, currentPage, state.existHeight);
    } else {
      let topicHeight = newTopicHeight + TH_HEIGHT + PADDING_TOP_HEIGHT;
      this.page.createNextPage(state.pageCell);
      currentPage++;
      this.page.insertNextPageHeadStack(
        state.pageCell[currentPage],
        topicHeight,
        this.type,
        this.cacheInnerHTML,
        {
          name: this.name,
          totalScore: this.totalScore,
          start: this.start,
          end: this.end,
          th: this.th,
          type: this.type,
          hasTitle: true,
          initDragHeight: this.initDragHeight || this.rowCount * TAG_P_HEIGHT + PADDING_TOP_HEIGHT,
          innerHTML: this.cacheInnerHTML,
        }
      );
      newTopicHeight = this.initDragHeight || this.rowCount * TAG_P_HEIGHT + PADDING_TOP_HEIGHT; // 12px是编辑器头部的高度
      this.recursionCutPage(state, newTopicHeight, currentPage, 0);
    }
  }
  resetPage(state: any,) {
    let newTopicHeight = 0
    let currentPage = state.pageCell.length - 1;
    let { acCardYJType } = answerPanelState.answerSheet;
    let TH_HEIGHT_NUM = TH_HEIGHT + acCardYJType == 2 ? 34 : 0
    if (this.page.isSurplusPage(state, currentPage, TH_HEIGHT_NUM + TAG_P_HEIGHT + 20)) {
      state.pageCell[state.pageCell.length - 1].fillTopiclist.push({
        ...this,
        hasTitle: true,
        initDragHeight: this.initDragHeight || this.rowCount * TAG_P_HEIGHT + PADDING_TOP_HEIGHT,
        innerHTML: this.cacheInnerHTML,
      });
      newTopicHeight = this.initDragHeight || this.rowCount * TAG_P_HEIGHT + PADDING_TOP_HEIGHT + TH_HEIGHT_NUM; // 12px是编辑器头部的高度
      this.recursionCutPage(state, newTopicHeight, currentPage, state.existHeight);
    } else {
      let topicHeight = newTopicHeight + TH_HEIGHT_NUM + PADDING_TOP_HEIGHT;
      this.page.createNextPage(state.pageCell);
      currentPage++;
      this.page.insertNextPageHeadStack(
        state.pageCell[currentPage],
        topicHeight,
        this.type,
        this.cacheInnerHTML,
        {
          name: this.name,
          totalScore: this.totalScore,
          start: this.start,
          end: this.end,
          th: this.th,
          type: this.type,
          hasTitle: true,
          initDragHeight: this.initDragHeight || this.rowCount * TAG_P_HEIGHT + PADDING_TOP_HEIGHT,
          innerHTML: this.cacheInnerHTML,
        }
      );
      newTopicHeight = this.initDragHeight || this.rowCount * TAG_P_HEIGHT + PADDING_TOP_HEIGHT; // 12px是编辑器头部的高度
      this.recursionCutPage(state, newTopicHeight, currentPage, 0);
    }
  }
  /**
   * 递归更新纸张的高度（每次判断当前纸张的高度是否超过，超过则递归裁剪高出的元素）
   */
  private recursionCutPage(
    state: any,
    newTopicHeight: number,
    currentPage: number,
    existHeight: number,
    isSelfCall?: boolean
  ) {
    let { acCardYJType } = answerPanelState.answerSheet;
    let cardGapHeight = acCardYJType == 2 ? 34 : 0
    existHeight = existHeight + (isSelfCall ? 0 : TH_HEIGHT) + cardGapHeight;
    // existHeight = existHeight + TH_HEIGHT;
    
    const currentMaxHeight = state.pageCell[currentPage].contentHeight;
    const canFillHeight = currentMaxHeight - existHeight; // 可填充高度
    let topicHeight = newTopicHeight + TH_HEIGHT ;
    const currentTopicStack =
      state.pageCell[currentPage].fillTopiclist[
      state.pageCell[currentPage].fillTopiclist.length - 1
      ];
    if (topicHeight > canFillHeight) {
      // this.cutOverHeight();
      this.cacheInnerHTML = this.addrResolveTopic(
        this.cacheInnerHTML,
        canFillHeight - (isSelfCall ? 0 : TH_HEIGHT),
        currentTopicStack
      );
      topicHeight -= canFillHeight;
      newTopicHeight = topicHeight;
      currentTopicStack.initDragHeight = currentMaxHeight - existHeight // BORDER_HEIGHT*2;
      currentTopicStack.isHurdle = true;
      this.page.createNextPage(state.pageCell);
      // state.currentPageNum++;
      currentPage++;
      this.page.insertNextPageHeadStack(
        state.pageCell[currentPage],
        topicHeight,
        this.type,
        this.cacheInnerHTML,
        this
      );
      this.recursionCutPage(state, newTopicHeight, currentPage, 0, isSelfCall);
    } else {
      // this.addrResolveTopic(this.cacheInnerHTML, topicHeight, currentTopicStack);
      currentTopicStack.initDragHeight = topicHeight; //直接将剩余的高度复制给最后
      currentTopicStack.isHurdle = false;
      currentTopicStack.innerHTML = this.cacheInnerHTML;
      // state.loadingInstance.close();
      return console.log('停止递归', currentPage);
    }
  }

  /**
   * 在下一页的头栈插入多出的高度
   */
  insertNextPageHeadStack(nextPageCell: any, overstepDistance: number, innerHTML?: string) {
    // nextPageCell.items.push({
    //   type: state.topticType || 1,
    // });

    nextPageCell.fillTopiclist.unshift({
      type: this.type,
      isHurdle: true, //当前item是否属于跨栏内容
      isResolved: false, // 题型是否分解
      initDragHeight: overstepDistance,
      innerHTML: innerHTML || '<p><u> test </u></p>',
    });
  }

  addrResolveTopic(innerHTML: string, canFillHeight: number, currentTopicStack: any): any {
    try {
      let ptags = innerHTML.split('</p>');
      ptags.pop();
      ptags = ptags.map(ptag => {
        return ptag + '</p>';
      });
      const dragPTags = Math.floor(canFillHeight / TAG_P_HEIGHT); // 拖拽高度四舍五入转换到p元素的个数
      const hurdleTags = ptags.splice(0, dragPTags); //剩余的数组 数组反转然后切割跨栏的小题
      // const result = ptags.join('');
      currentTopicStack.innerHTML = hurdleTags.join('');
      currentTopicStack.isResolved = true; //设置当前分解stack题型是否是分解
      return ptags.join('');
      // return result;
    } catch (e) {
      console.error('分解题型报错', e.message);
    }
  }
}
